module.exports = __webpack_public_path__ + "img/background-products.f52b599f.jpg";